import { Component, Input, OnInit } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { IBaryInput } from 'models/bary-input';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'jhi-bary-input-radio-button',
  templateUrl: './bary-input-radio-button.component.html',
  styleUrls: ['./bary-input-radio-button.component.scss'],
})
export class BaryInputRadioButtonComponent implements IBaryInput, OnInit {
  @Input() id: string = BaryComponentHelper.makeId();
  @Input() label?: string;
  @Input() name?: string;
  @Input() inline: boolean = true;
  @Input() disabled: boolean = false;

  @Input() leftValue?: string;
  @Input() middleValue?: string;
  @Input() rightValue?: string;
  @Input() leftLabel?: string;
  @Input() middleLabel?: string;
  @Input() rightLabel?: string;
  @Input() leftTooltip?: string;
  @Input() middleTooltip?: string;
  @Input() rightTooltip?: string;

  @Input() control = new FormControl('');

  leftId!: string;
  middleId!: string;
  rightId!: string;

  public ngOnInit(): void {
    this.leftId = BaryComponentHelper.genId(this.id, 'left');
    this.middleId = BaryComponentHelper.genId(this.id, 'middle');
    this.rightId = BaryComponentHelper.genId(this.id, 'right');
  }
}
